import { CancelTokenSource } from 'axios';

import {
  ChartVolumeAndPriceDataTypes,
  ChartVolumeAndPriceParamsTypes,
  GetPriceHistoriesParamsTypes,
  GetTHShareholderTransactionsParamsTypes,
  ListGroupByMinuteTodayDataTypes,
  PriceHistoriesTypes,
  THShareholderTransactionsTypes,
  ChartListOverallTypes,
  ChartListInformationTypes,
  PriceHistoriesParamsTypes,
} from './types';

import axiosInstance from 'services/common/instance';

export const getPriceHistoriesService = async (
  params: PriceHistoriesParamsTypes,
): Promise<PaginationData<PriceHistoriesTypes[]>> => {
  const response = await axiosInstance.get('stock-quotes/price-histories', { params: params.param, cancelToken: params.source });
  return response.data;
};

export const getShareholderTransactionsService = async (
  params: GetTHShareholderTransactionsParamsTypes,
): Promise<PaginationData<THShareholderTransactionsTypes[]>> => {
  const response = await axiosInstance.get('ttpt-shareholder-transactions', { params });
  return response.data;
};

export const getChartListOverallService = async (
  params: Pick<GetPriceHistoriesParamsTypes, 'stock_symbol'>,
  source?: CancelTokenSource,
): Promise<ChartListOverallTypes> => {
  const response = await axiosInstance.get('ttpt-ws-order-matching/current', { params, cancelToken: source?.token });
  return response.data.data;
};

export const getChartListInformationService = async (
  params: Pick<GetPriceHistoriesParamsTypes, 'stock_symbol'>,
  source?: CancelTokenSource,
): Promise<ChartListInformationTypes[]> => {
  const response = await axiosInstance.get('ttpt-ws-order-matching/chart-volume-and-price-by-today', { params, cancelToken: source?.token });
  return response.data.data;
};

export const getChartVolumeAndPriceService = async (
  params: ChartVolumeAndPriceParamsTypes,
  source?: CancelTokenSource,
): Promise<ChartVolumeAndPriceDataTypes[]> => {
  const response = await axiosInstance.get('ttpt-ws-order-matching/chart-volume-and-price', { params, cancelToken: source?.token });
  return response.data.data;
};

export const getListGroupByMinuteTodayService = async (
  params: Pick<GetPriceHistoriesParamsTypes, 'stock_symbol'>,
  source?: CancelTokenSource,
): Promise<ListGroupByMinuteTodayDataTypes[]> => {
  const response = await axiosInstance.get('ttpt-ws-order-matching/list-group-by-minute-today', {
    params,
    cancelToken: source?.token,
  });
  return response.data.data;
};
